import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import VerifyTokenForm from './VerifyTokenForm';
import toastr from 'toastr';
import {withRouter} from 'react-router';

import {
  verifyPasswordResetToken,
} from '../actions';

import React, {Component, PropTypes} from 'react';

class VerifyPasswordResetTokenPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  render() {
    const {invalidToken, verifyPasswordResetToken} = this.props;
    const {userId, token} = this.props.params;

    return (
      <VerifyTokenForm
        verifyToken={verifyPasswordResetToken}
        invalidToken={invalidToken}
        pushedRoute={`reset-password/${userId}/${token}`} />
    );
  }
}

VerifyPasswordResetTokenPage.propTypes = {
  params: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  invalidToken: PropTypes.bool.isRequired,
  verifyPasswordResetToken: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {verifyPasswordResetToken} = state.features.passwordManagement.pages;

  return {
    invalidToken: verifyPasswordResetToken.get('invalidToken'),
  };
}

export default withRouter(connect(
  mapStateToProps, {
    verifyPasswordResetToken,
  }
)(VerifyPasswordResetTokenPage));



// WEBPACK FOOTER //
// ./app/features/passwordManagement/components/VerifyPasswordResetTokenPage.js